module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Ge-Hc-Ib-Jb.775519f6.png";